// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9d1d0717","182":"46662e3b","184":"8fbe9123"}[chunkId] + ".chunk.js";
};